import React from "react";
import { Container } from "../../components/container";

const CITIES = [
  { name: "Boston", image: "/explore/Photo.png" },
  { name: "Chicago", image: "/explore/Photo-1.png" },
  { name: "Denver", image: "/explore/Photo-2.png" },
  { name: "San Francisco", image: "/explore/Photo-3.png" },
  { name: "Dallas", image: "/explore/Photo-4.png" },
  { name: "Brooklyn", image: "/explore/Photo-5.png" },
  { name: "Cleveland", image: "/explore/Photo-6.png" },
  { name: "Charlotte", image: "/explore/Photo-7.png" },
  { name: "Minnesota", image: "/explore/Photo-8.png" },
  { name: "Houston", image: "/explore/Photo-9.png" },
  { name: "New York City", image: "/explore/Photo-10.png" },
  { name: "Detroit", image: "/explore/Photo-11.png" },
  { name: "Miami", image: "/explore/Photo-12.png" },
  { name: "Oklahoma City", image: "/explore/Photo-13.png" },
  { name: "Los Angeles", image: "/explore/Photo-14.png" },
  { name: "Memphis", image: "/explore/Photo-15.png" },
  { name: "Philadelphia", image: "/explore/Photo-16.png" },
  { name: "Indiana", image: "/explore/Photo-17.png" },
  { name: "Orlando", image: "/explore/Photo-18.png" },
  { name: "Portland", image: "/explore/Photo-19.png" },
  { name: "Phoenix", image: "/explore/Photo-20.png" },
  { name: "New Orleans", image: "/explore/Photo-21.png" },
  { name: "Toronto", image: "/explore/Photo-22.png" },
  { name: "Milwaukee", image: "/explore/Photo-23.png" },
  { name: "Washington D.C.", image: "/explore/Photo-24.png" },
  { name: "Utah", image: "/explore/Photo-25.png" },
  { name: "Sacramento", image: "/explore/Photo-26.png" },
  { name: "San Antonio", image: "/explore/Photo-27.png" },
  { name: "Atlanta", image: "/explore/Photo-28.png" },
  { name: "Las Vegas", image: "/explore/Photo-29.png" },
];

function Explore() {
  return (
    <section className="bg-[#817B50]" id="explore" aria-label="Explore cities">
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-5 lg:gap-32 justify-items-start">
          <h2 className="font-ppacma text-[56px] md:text-8xl leading-[90%] break-words hyphens-auto mt-6">
            <span className="text-white">Explore Every</span>{" "}
            <br className="hidden md:block" />
            <span className="text-black">City Like a Local</span>
          </h2>

          <p className="text-white text-[18px] font-normal leading-[120%] tracking-[0px] mt-[24px] mb-7 self-end max-w-[462px]">
            <strong>League Life</strong> highlights curated recommendations,
            hidden gems, and local insights to help families feel at home in any
            city. From dining and entertainment to wellness and cultural
            experiences, we make it easy to discover what matters most.
          </p>
        </div>

        {/* Cities Grid - Desktop */}
        <div className="hidden md:grid md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5   2xl:grid-cols-6 gap-6 md:gap-9 md:py-16">
          {CITIES.map((city) => (
            <article
              key={city.name}
              className="flex flex-col items-center gap-2"
            >
              <div className="w-[201px] aspect-square rounded-full overflow-hidden">
                <img
                  src={city.image}
                  alt={`${city.name} city guide and local recommendations`}
                  className="object-cover w-[201px] h-[201px]"
                  loading="lazy"
                  width="201"
                  height="201"
                />
              </div>
              <h3 className="text-white text-center font-semibold text-2xl">
                {city.name}
              </h3>
            </article>
          ))}
        </div>

        {/* Cities List - Mobile */}
        <nav
          className="md:hidden grid grid-cols-2 gap-x-4"
          aria-label="Cities list"
        >
          {CITIES.map((city) => (
            <div
              key={city.name}
              className="text-white text-lg font-normal py-4 border-t border-white/30"
            >
              {city.name}
            </div>
          ))}
        </nav>
      </Container>
    </section>
  );
}

export { Explore };
